module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/TV2-be8f01d40c2582bd5379bd7dc59c0b43.svg";